import './detail.css';
import { Remove, Add } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import React, { useState, useContext, useEffect } from 'react';
import FormSelect from '../form-select/select';
import ProgressBar from '../progress/progressBar';
import api from '../../service/api';
import SingleValue from './base/single-value-update';
import MultiValue from './base/multi-value';
import IdentifiersView from './input/identifiers-view';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useParams } from "react-router-dom";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { 
    Accordion, AccordionSummary, Tooltip,
    AccordionDetails, Button, Chip, IconButton, Typography,
    Stack
} from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link } from 'react-router-dom';
import NewRelation from './input/relation-update';
import Popup from './error/popup';
import CONSTANT from '../../Constant/Constant';
import NestedSearch from './base/search';
import filter from '../../service/filter';
import Storage from '../../session/storage';
import moment from 'moment';
import jsondata from "../../config/ProfileDetailsData.json"
import profileDetail from "../../config/EditProfileDetails.json"
import CountryCodeBase from "../../config/countryCodeBaseIqvia.json"
import popUpMessage from '../../config/popUpMsg.json'
import payloadCountryConfig from "../../config/vendorPicklistApiPayload.json"
import ProfileIcon from '../shared/ProfileIcon';
import { DirectionContext } from '../../context/DirectionProvider';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import {styled} from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import Consents from './consents';
import searchHCOPayload from '../../config/NewHCPFormFields.json'
import useLocalStorage from '../../hooks/useLocalStorage';
import {DropdownContext}  from '../../context/DropDownContext';
import SpecialtyPopup from './input/specialty_popup';


const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
}));

// custom style for tooltip for width
const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: "none",
      
    },
});

const Details = (props) => {
    const direction = useContext(DirectionContext);
    const { setDropdownValue } = useContext(DropdownContext)
    const classes = useStyles();
    const [showError, setShowError] = useState(false);
    const [editable, setEditable] = useState('Viewing');
    const [modalOpen, setModalOpen] = useState();
    const [progressFlag, setProgressFlag] = useState(true);
    const [errorFlag, setErrorFlag] = useState(false);
    const [submitFlag, setSubmitFlag] = useState();
    const [errorMsg, setErrorMsg] = useState('Internal Server Error')
    const [detail, setDetail] = useState();
    const [updateDetails, setUpdateDetail] = useState(undefined);
    let { id, entity } = useParams();
    const [accordian, setAccordian] = useState(true);
    const HCP = entity === 'HCP';
    const [validRequest, setValidRequest] = useState();
    const [controlOption, setControlOption] = useState(null);
    const [addNewRelation, setNewRelation] = useState(false);
    const [indexView, setIndexView] = useState(CONSTANT.SHOW_VALUE_NUMBER);
    const [relationData, setRelationData] = useState([]);
    const [allRelation, setAllRelation] = useState([])
    const [typeHCP, setType] = useState();
    const [changeCompleted, setChangeCompleted] = useState();
    const [data] = useState(jsondata);
    const [profileData] = useState(profileDetail)
    const [filterdata, setfilterdata] = useState()
    const [countryData, setcountryData] = useState();
    const [staticdata, setstaticdata] = useState();
    const [consentProgressBar, setConsentProgressBar] = useState(false);
    const [consentError, setConsentError] = useState('')
    const [consentData, setConsentData] = useState(false);
    const [value, setValue] = React.useState('1');
    const [errorMessage] = useState(popUpMessage.profileDetail)
    const [consent, setconcent] = useState()
    const [consentKeys, setConsentKeys] = useState()
    const [consentAttempt, setConsentAttempt] = useState(0)
    const [dropDownOptionFlag, setDropDownOptionsFlag] = useState()
    const [relationsAfterFiltering, setRelationsAfterFiltering] = useState([])
    const [identifierSubmit, setIdentifierSubmit] = useState(false) 
    const [noIdentifierData, setNoIdentifierData] = useState(false)
    const [originalValue, setOriginalValue] = useState('')
    const [dcrSource, setDcrSource] = useState('')
    const [identifierData]= useState({})
    const [specialtyEdit, setSpecialtyEdit] = useState(false)
    const [addressEditIndex, setAddressEditIndex] = useState({})
    const [sourceData, setSourceData] = useState()
    const [showSpecialtyPopup, setShowSpecialtyPopup] = useState(false)
    const [specialtyDataSaved, setSpecialtyDataSaved] = useState(false)
    const [specialtyList, setSpecialtyList] = useState()
    const [separateSingleKeySectionDataAvailability, setSeparateSingleKeySectionDataAvailability] = useState()
    const [showAllSpecialty, setShowAllSpecialty] = useState({Specialities: [], NewSpecialities: []})
    const [isEmployer, setIsEmployer] = useState(false)
    let showConfirmationButtonn = false
    let showAddressDeactivationMessage = false
    var payloadCountry
    let filterVNDRCGDMRelatioData;
    const [langLocaleChange] = useLocalStorage('wglang_api')

    useEffect(() => {
        if (detail?.entity && editable.includes('Edit')) {

            setValidRequest(undefined);
            //(true);
            let sourceForUiPicklist = checkSource(detail.entity.Source);
            setDcrSource(checkSource(detail.entity.Source));
            api.getPickList((payloadCountry ? payloadCountry.key.payloadKey : detail.entity.CountryCode[0].value), sourceForUiPicklist[0].value, undefined, (detail.entity.type.split('/')[2] == 'HCP' ? 'HCP' : 'HCO'), undefined, langLocaleChange).then((res) => {
                if (detail.entity.CountryCode[0].value === "United States") {
                    entity === "HCO" ?
                        Storage.setLovBoundedList(filter.mapPickList(res.data[0])) :
                        Storage.setLovBoundedList(filter.mapVnPickList(res.data[0]))
                } else {
                    Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
                    setDropdownValue(filter.mapPickList(res.data[0]))
                }
                setProgressFlag(false);
                setValue('1');
            }).catch((error) => {
                let errorDetail = error;
                let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
                setErrorMsg(msg ? msg : 'Internal Server Error!');
                setProgressFlag(false);
            })
        }
    }, [langLocaleChange])
    
    /**
     * close the accordian
     * @param {*} prev : previous state of accordian
     */
    const closeAccordian = (prev) => {
        setAccordian(!prev)
    }
    /**
     * handel the vie mode in detail page
     * @param {*} flag : value to show options based on DCR flag 
     */
    const dropDownOption = () => {
        // setControlOption(dropDownOptionFlag ? (CONSTANT.VIEW_OPTIONS) : ([CONSTANT.VIEW_OPTIONS[0]]));

        const date = detail?.entity?.EffectiveStartDate ? new Date(detail?.entity?.EffectiveStartDate[0]?.value) : null;
        const datePlus = new Date(date)
        datePlus.setDate(datePlus.getDate() + 30);
        const isExpired = date && datePlus < new Date();

        if(detail && detail?.entity && detail?.entity?.Source?.[0]?.value === "MNGD-AFF" && detail?.entity?.OriginalSource?.[0]?.value === "LLY-MNGD" && detail?.is_lly_aff_vrfctn_allowed && (CONSTANT.SHELL_PROFILE_VALIDATION_REASON_CODE?.includes(detail?.entity?.ValidationReasonCode?.[0]?.value) ? detail?.entity?.ValidationReasonCode?.[0]?.value === 'Vendor Rejected' ? true : isExpired : false) ){
            setControlOption(dropDownOptionFlag ? (CONSTANT.VIEW_OPTIONS_LLY_VERIFIED_EDIT) : (CONSTANT.VIEW_OPTIONS_LLY_VERIFIED));
        }
        else if(detail && detail?.entity && detail?.entity?.Source?.[0]?.value === "MNGD-AFF" && detail?.entity?.OriginalSource?.[0]?.value === "LLY-MNGD" && (CONSTANT.SHELL_PROFILE_VALIDATION_REASON_CODE?.includes(detail?.entity?.ValidationReasonCode?.[0]?.value))){
            setControlOption(CONSTANT.VIEW_OPTIONS_LLY_VERIFIED_VIEW_OPTION);
        }
        else setControlOption(dropDownOptionFlag ? (CONSTANT.VIEW_OPTIONS) : ([CONSTANT.VIEW_OPTIONS[0]]));
    }
    /**
     * 
     * @param {*} event : handled the tab change profile and consents
     * @param {*} newValue 
     */
    const handleChangeTab = (event, newValue) => {
        
        if (newValue == 2 && !consentData && consentAttempt != CONSTANT.CONSENTS_ATTEMPTS)
        {
            setConsentError('')
            setConsentProgressBar(true)
            setConsentAttempt(consentAttempt + 1)
            api.getConsents(detail.entity.primary_HCPReferenceId[0].value).then((res)=>{
                let consentResponse = res.data;            
                setConsentKeys(Object.keys(consentResponse))
                setconcent(consentResponse)
                setConsentData(true)
                setValue(newValue)
                setConsentProgressBar(false)
            }).catch((error)=>{
                setConsentProgressBar(false)
                setConsentError('Error')
                

            })

            // let consentResponse = gccp;
            //     setConsentKeys(Object.keys(consentResponse))
            //     setconcent(consentResponse)
            //     setConsentData(true)
            //     setValue(newValue)
        }
        else if(newValue == 2 && consentAttempt == CONSTANT.CONSENTS_ATTEMPTS && !consentData  )
        {
            
        }
        else{
            setValue(newValue);
        }
    }
      
    /**
     * mockung the undefined value of detail page
     * @param {*} value  : one value
     * @returns mocked value for undefined
     */
    const mockUndefined = (value) => {
        return value ? value : [{ value: undefined }]
    }
    
    /**  getting config data as per the country */
    const get = (countryValue, sourceData) => {  
        var getSource = checkSource(sourceData)      
        var getdata = profileData.Countries.find((el) => {
            if (el.country_name === countryValue) {
                return el.country_name == countryValue
            }
            else {
                return el.country_name === "Default"
            }
        })
        if (getSource && (data.VENDOR_MANAGED_SOURCES).includes(getSource[0]['value'])) {           
            setIsEmployer(false)
            setfilterdata(getdata.Input.IQVIA)
        }
        else if (getSource && (data.LILLY_MANAGED_SOURCES).includes(getSource[0]['value'])) {           
            setIsEmployer(false)
            setfilterdata(getdata.Input.EPH)
        }
        else if (getSource && (data.EMPLOYER_DATA_SOURCES).includes(getSource[0]['value'])) {
            setIsEmployer(true)
            setfilterdata(getdata.Input_EMP.EMPLOYER)
        }
        else if (getSource && (data.OPEN_DATA_SOURCES).includes(getSource[0]['value'])) {         
            setIsEmployer(false)
            setfilterdata(getdata.Input.OPEN_DATA)       
        }
        else {
            
            filterdata === undefined && setfilterdata(getdata.Input.OTHER_SOURCES)
        }   
        if(getSource && (data.EMPLOYER_DATA_SOURCES).includes(getSource[0]['value'])){
            setstaticdata(getdata.Input_EMP)
            if(getdata.Input_EMP.hcpeditable === true){
                // sethcpeditableflag(true)
                return true;
            } else {
                // sethcpeditableflag(false)
                return false;
            }
        } else {
            setstaticdata(getdata.Input)
            if(getdata.Input.hcpeditable === true){
                // sethcpeditableflag(true)
                return true;
            } else {
                // sethcpeditableflag(false)
                return false;
            }
        }
    }
    /**
     * checks the sources weather they are lilly or vender managed
     * @param {*} sources :List of Sources
     * @returns :one source value
     */
    const checkSource = (sources) => {
        let lillySource = [];
        if ((sources === undefined) || (Object.keys(sources).length === 0)) {                     
            return sources;
        } else if (typeof(sources) == 'string'){
            if(CONSTANT.ALL_SOURCES.includes(sources)){
                return CONSTANT.LILLY_SOURCES_VALUES[sources]
            }
        } else {       
            sources.forEach((source) => {                
                if (CONSTANT.ALL_SOURCES.includes(source.value)) {                                   
                    lillySource.push(source.value);                    
                }                
            })
        }        
        if (lillySource.length === 0) {     
            return sources;
        }else if(lillySource.length == 1){           
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[lillySource[0]] }]
            } else{                          
                if(lillySource.every((res)=>  CONSTANT.LILLY_SOURCES_FOR_EDIT_PROFILE.includes(res))){
                    return [{value: CONSTANT.LILLY_SOURCES_VALUES['MNGD-AFF']}]
                } else if(lillySource.every((res)=>  CONSTANT.VENDOR_SOURCE.includes(res) )){                
                    return null
                } else if (lillySource.includes(CONSTANT.VENDOR_SOURCE[0])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.VENDOR_SOURCE[0]]}]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[0])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[0]] }]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[1])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[1]] }]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[2])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[2]] }]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[3])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[3]] }]
                }
            }
    }

    /**
     * function for country payload for picklist
     * 
     */
    
    const getPaylodCountry = (country) => {
        
        payloadCountry = payloadCountryConfig.countries.find((res) => res.country_Name === country);
    }


    /**
     * handel the view mode change
     * @param {*} event : value of mode
     */
    const changeOperation = async (event) => {
        getPaylodCountry(detail.entity.CountryCode[0].value)
        if(event.target.value === 'Edit' || event.target.value === 'Mark as Lilly Verified and Edit'){
            setValidRequest(undefined);
            setProgressFlag(true);
            if(event.target.value === 'Mark as Lilly Verified and Edit'){
                setOriginalValue({ ...originalValue, ['ValidationReasonCode']: detail?.entity['ValidationReasonCode'] })
                setUpdateDetail({ ...updateDetails, entity: { ...updateDetails?.entity, ['LillyVerified']: true, ['ValidationReasonCode']: [{ 'value': 'Lilly Verified' }] } })
                // updateDetails['entity']['LillyVerified'] = true
            }
            let sourceForUiPicklist = checkSource(detail.entity.Source)
            setDcrSource(checkSource(detail.entity.Source))
            api.getPickList((payloadCountry ? payloadCountry.key.payloadKey : detail.entity.CountryCode[0].value ) , sourceForUiPicklist[0].value, undefined, (detail.entity.type.split('/')[2] == 'HCP' ? 'HCP' : 'HCO'), undefined, langLocaleChange ).then((res) => {
                if (detail.entity.CountryCode[0].value === "United States" ) {
                    entity === "HCO" ? 
                    Storage.setLovBoundedList(filter.mapPickList(res.data[0])) : 
                    Storage.setLovBoundedList(filter.mapVnPickList(res.data[0]))
                }else{
                    Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
                    // setDropdownValue(filter.mapPickList(res.data[0]))
                }

                setProgressFlag(false);
                setEditable(event.target.value);
                setValue('1');
            }).catch((error) => {
                let errorDetail = error;
                let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
                setErrorMsg(msg ? msg : 'Internal Server Error!');
                setProgressFlag(false);
            })
            if (typeHCP) {
                CONSTANT.EDITABLE_ATTRIBUTE.forEach(key => {
                    if ((key === "SecondaryLastName"  &&
                     CONSTANT.RESTRICT_COUNTRY.includes(detail.entity.CountryCode[0].value) )
                     && (!detail.entity[key] ||  detail.entity[key].value === ''))
                    {
                        setSubmitFlag((oldValue) => {
                            return { ...oldValue, [key]: true }
                        });
                    }
                    if (key !== "SecondaryLastName"){
                        let value = detail.entity[key];
                        if (value === undefined || value[0].value === '') {
                            setSubmitFlag((oldValue) => {
                                return { ...oldValue, [key]: true }
                            });
                        }
                    }
                })
            } else {
                CONSTANT.EDITABLE_ATTRIBUTE_HCO.forEach(key => {
                    let value = detail.entity[key];
                    if (value === undefined || value[0].value === '') {
                        setSubmitFlag((oldValue) => {
                            return { ...oldValue, [key]: true }
                        });
                    }
                })
            }

        } else if(event.target.value === 'Mark as Lilly Verified'){
            setProgressFlag(true);
            setEditable(event.target.value);
            setProgressFlag(false);
            setDcrSource(checkSource(detail.entity.Source))
            setOriginalValue({ ...originalValue, ['ValidationReasonCode']: detail?.entity['ValidationReasonCode'] })
            setUpdateDetail({ ...updateDetails, entity: { ...updateDetails?.entity, ['LillyVerified']: true, ['ValidationReasonCode']: [{ 'value': 'Lilly Verified' }] } })
            // updateDetails['entity']['LillyVerified'] = true
            changeDetails()
        } else {
            await setEditable(event.target.value);
            setShowError(false);
        }

    }

    /**
     * Check Rank of existing address and new address
     * @param {*} address : address object
     */
    const checkAddressRank = () => {
        let existingAddress = detail?.entity?.Address;
        let newAddress = updateDetails?.entity?.AddAddress;
        let existingUpdatedAddress = updateDetails?.entity?.Address;

        if(newAddress?.length > 0 &&  existingAddress?.length > 0 && existingUpdatedAddress?.length > 0){
            //check rank 2 available in new address
            let checkNewRankOne = newAddress.some((newAdd, index) => newAdd.Rank?.[0]?.value != 1)
            let filtereActivedAddresses =  existingUpdatedAddress.filter((existing, index) => existing.Rank?.[0]?.value == 1 && existing.EffectiveEndDate?.[0]?.value > moment.utc(new Date()).format("YYYY-MM-DD")  )

            let filteredAddresses =  existingAddress.filter((existingAddr) => 
                existingUpdatedAddress.some((updatedAddr) => updatedAddr.SourceAddressId[0].value !== existingAddr.SourceAddressId[0].value)
            ); 

            let hasRankOneAndActive = filteredAddresses.some((address) => 
                address?.Rank?.[0]?.value === 1 && address?.EffectiveEndDate?.[0]?.value > moment.utc(new Date()).format("YYYY-MM-DD")
            );
            // If filteredAddresses is empty or no address meets the criteria, notify
            if (filtereActivedAddresses.length !== 0 || !checkNewRankOne) {
                return false
            }
            else if(filteredAddresses.length === 0 || !hasRankOneAndActive ){
                showConfirmationButtonn = false
                return true
            }        
            return false

        }else if(newAddress?.length > 0 &&  existingAddress?.length > 0){
            let checkRankOne = existingAddress.some((existing, index) => existing.Rank?.[0]?.value == 1 && existing.EffectiveEndDate?.[0]?.value > moment.utc(new Date()).format("YYYY-MM-DD") )
            let checkNewRankOne = newAddress.some((newAdd) => newAdd.Rank?.[0]?.value != 1)

            return !checkRankOne && checkNewRankOne
        }else if (existingAddress?.length > 0 && existingUpdatedAddress?.length > 0) {
            
            let filtereActivedAddresses =  existingUpdatedAddress.filter((existing, index) => existing.Rank?.[0]?.value == 1 && existing.EffectiveEndDate?.[0]?.value > moment.utc(new Date()).format("YYYY-MM-DD")  )

            
            // Filter existingUpdatedAddress by matching addressSourceId to existingAddress object
            let filteredAddresses =  existingAddress.filter((existingAddr) => 
                existingUpdatedAddress.some((updatedAddr) => updatedAddr.SourceAddressId[0].value !== existingAddr.SourceAddressId[0].value)
            );
            // Check if any of the filtered addresses have Rank 1 and Active flag 'Y'
            let hasRankOneAndActive = filteredAddresses.some((address) => 
               address?.Rank?.[0]?.value === 1 && address?.EffectiveEndDate?.[0]?.value > moment.utc(new Date()).format("YYYY-MM-DD")
            );

            // If filteredAddresses is empty or no address meets the criteria, notify
            if (filtereActivedAddresses.length !== 0) {
                return false
            }
            else if(filteredAddresses.length === 0 || !hasRankOneAndActive){
                showConfirmationButtonn = true
                return true
            }
            return false;
        }
        else if(newAddress?.length > 0){
            let checkNewRankOne = newAddress.some((newAdd) => newAdd.Rank[0].value != 1)
            return checkNewRankOne
        }
        else{
            return false
        }
    }

    const addressDeactivationValidation = () => {
        let existingAddress = detail?.entity?.Address;
        let newAddress = updateDetails?.entity?.AddAddress;
        let existingUpdatedAddress = updateDetails?.entity?.Address;

        // get the deactivated address from existingUpdatedAddress
        let deactivatedAddresses = existingUpdatedAddress?.filter((addr) => addr.EffectiveEndDate[0].value <= moment.utc(new Date()).format("YYYY-MM-DD"))


        // get activated address from existingUpdatedAddress with effectiveend date = "9999-12-31" and IsStatusChanged=true
        let activatedAddresses = existingUpdatedAddress?.filter((addr) => addr.EffectiveEndDate[0].value === "9999-12-31" && 
                                                            addr.IsStatusChanged != undefined && addr.IsStatusChanged)

        // check if new addres has rank 1 address
        let newAddressHasRankOne = newAddress?.some((newAdd) => newAdd.Rank[0].value == 1)

        //check if deactivated address has rank 1
        let deactivatedHasRankOne = deactivatedAddresses?.some((deactAddr) => deactAddr.Rank[0].value == 1)

        // check if activated address has rank 1
        let activatedHasRankOne = activatedAddresses?.some((actAddr) => actAddr.Rank[0].value == 1)

        // check if all the addrress on existingUpdatedAddress are deactivated and existingAddress count is same as existingUpdatedAddress
        if(existingUpdatedAddress?.length > 0 && existingAddress?.length > 0 && existingUpdatedAddress?.length === existingAddress?.length && deactivatedAddresses?.length === existingUpdatedAddress?.length && !deactivatedHasRankOne){
            showConfirmationButtonn = true
            return true
        } 
        else if( deactivatedAddresses?.length > 0  && !newAddressHasRankOne && deactivatedHasRankOne && !activatedHasRankOne){
            showConfirmationButtonn = true
            showAddressDeactivationMessage = true
            return true
        } 
        return false
    }
 
    const checkRelationRank = () => {
        let existingRelation = detail?.relations
        let newRelation = updateDetails.relations

        if(newRelation?.length > 0 &&  existingRelation?.length > 0 ){
            //check rank 2 available in new address
            let checkNewRankOne = newRelation?.some((newAdd, index) => newAdd?.Rank != undefined)
            let filteredDeactivatedRelation =  newRelation.filter((rel, index) => rel.IsStatusChanged != undefined)           


            if(checkNewRankOne && filteredDeactivatedRelation.length !== 0){
                let checkNewRankOne = newRelation?.some((newAdd, index) => newAdd?.Rank != undefined && newAdd?.Rank[0].value == 1)
                let filteredDeactivatedRelation =  newRelation.filter((rel, index) => rel.IsStatusChanged != undefined)
                let activeRelationPresent = findRankOneRelation(filteredDeactivatedRelation)

                let filteredExistingRelation =  existingRelation.filter((existingReln) => 
                    filteredDeactivatedRelation.some((updatedReln) => updatedReln.uri !== existingReln.uri)
                ); 
                let activeRelationPresentExisting = findRankOneRelation(filteredExistingRelation)

                if(checkNewRankOne){
                    return false
                }else if(activeRelationPresent){
                    return false
                }else if(activeRelationPresentExisting){
                    return false
                }else{
                    showConfirmationButtonn = false
                    return true
                }
            }
            else if(checkNewRankOne){
                let checkRankOnePresent = newRelation?.some((newAdd, index) => newAdd?.Rank != undefined && newAdd?.Rank[0].value == 1)
                let activeRelationPresent = findRankOneRelation(existingRelation)
                
                if(checkRankOnePresent){
                    return false
                }else if(activeRelationPresent){
                    return false
                }else{
                    showConfirmationButtonn = false
                    return true
                }


            }else if(filteredDeactivatedRelation.length !== 0 ){
                let checkRankOnePresent = newRelation?.filter((newAdd, index) => newAdd?.ActiveFlag != undefined && newAdd?.ActiveFlag[0].value == 'Y')
                let rankOnePresent = checkRankOnePresent.some((newAdd) => 
                    newAdd?.AffiliationClassification?.some((classification) => 
                        classification?.Rank && classification?.Rank[0]?.value === '1')
                    )
                let filteredRelation =  existingRelation.filter((existingReln) => 
                    newRelation.some((updatedReln) => updatedReln.uri !== existingReln.uri)
                );
                let activeRelationPresent = findRankOneRelation(filteredRelation)

                if(checkRankOnePresent.length !== 0 && rankOnePresent){
                    return false
                }else if(activeRelationPresent){
                    return false
                }else{
                    showConfirmationButtonn = true
                    return true
                }         
            }
        }else if(newRelation?.length > 0){
            let checkRankOnePresent = newRelation?.some((newAdd, index) => newAdd?.Rank != undefined && newAdd?.Rank[0].value == 1)
            let activeRelationPresent = findRankOneRelation(existingRelation)
            
            if(checkRankOnePresent){
                return false
            }else if(activeRelationPresent){
                return false
            }else{
                showConfirmationButtonn = false
                return true
            }
        }

    }

    const checkSpecialtyRank = () => {
        let existingSpecialty = detail?.entity?.Specialities
        let newSpecialty = updateDetails?.entity?.NewSpecialities
        let existingDeactivatedSpecialty = updateDetails?.entity?.Specialities?.filter((existing, index) => existing.isDeleted != undefined)       
        
        if(newSpecialty != undefined && Object.keys(newSpecialty)?.length > 0 &&  existingDeactivatedSpecialty?.length > 0 ){
            let checkRankOnePresent = Object.keys(newSpecialty)?.includes('PrimarySpecialty')

            // cehck PriamrySpeciality present existing specialty with in Replacement attribute
            let checkRankOneForReplacement
            if(existingDeactivatedSpecialty?.length > 0){
                checkRankOneForReplacement = existingDeactivatedSpecialty.some((existingSpeci) => existingSpeci.Replacement && "PrimarySpecialty" in existingSpeci.Replacement )
            }

            let checkNonDeactivatedSpecialty =  existingSpecialty.filter((existingSpeci) => 
                existingDeactivatedSpecialty.some((updatedSpeci) => updatedSpeci.uri !== existingSpeci.uri)
            ); 
            
            let checkRankOneremainingPresent = checkNonDeactivatedSpecialty.some((existingSpeci) =>  existingSpeci.Rank && existingSpeci.Rank[0].value == 1 )
                
            if(checkRankOnePresent){
                return false
            }else if(checkRankOneremainingPresent ){
                return false              
            }else if (checkRankOneForReplacement){
                return false
            }
            else{
                return true
            } 
           
        }else if(newSpecialty != undefined  && Object.keys(newSpecialty)?.length > 0){

            let checkRankOnePresent = Object.keys(newSpecialty)?.includes('PrimarySpecialty')
            
            let checkRankOne = existingSpecialty.some((existing, index) => existing.Rank[0].value == 1 )         
            
            if(checkRankOnePresent){
                return false            
            }else if(checkRankOne){
                return false            
            }else{
                return true
            }
        }else if(existingDeactivatedSpecialty?.length > 0){  
            let checkNonDeactivatedSpecialty =  existingSpecialty.filter((existingSpeci) => 
                existingDeactivatedSpecialty.some((updatedSpeci) => updatedSpeci.uri !== existingSpeci.uri)
            );            
            let checkRankOneremainingPresent = checkNonDeactivatedSpecialty.some((existingSpeci) => existingSpeci.Rank[0].value == 1 )
            
            
            // cehck PriamrySpeciality present existing specialty with in Replacement attribute
            let checkRankOneForReplacement
            if(existingDeactivatedSpecialty?.length > 0){
                checkRankOneForReplacement = existingDeactivatedSpecialty.some((existingSpeci) => existingSpeci.Replacement && "PrimarySpecialty" in existingSpeci.Replacement)
            }
            if(checkRankOneremainingPresent){
                return false
            }else if (checkRankOneForReplacement){
                return false
            }
            else{
                showConfirmationButtonn = false
                return true
            }
        }

    }

    const findRankOneRelation = (relation) => {
        return relation?.some(item => {
            // Check if ActiveFlag in the main item is 'Y'
            const isMainActive = item?.ActiveFlag?.some(flag => flag.value === "Y");
            
            // Check if AffiliationClassification contains Rank 1 (without checking ActiveFlag)
            const isAffiliationValid = item?.AffiliationClassification?.some(aff =>
              aff?.Rank?.some(rank => rank.value === "1")
            );
            
            // Return true if both conditions are met, otherwise false
            return isMainActive && isAffiliationValid;
        });
    }

    const allowDeactivation = () => {
        setModalOpen({
            flag: true,
            message: 'Comments *',
            success: true,
            title: errorMessage[0].submitRequest.heading
        })

    }
    /**
     * final submission of DCR
     */
    const changeDetails = () => {
        let submit = false;
        let changes = false;
        if (submitFlag !== undefined && validRequest !== undefined) {
            Object.keys(submitFlag).forEach(key => {
                submit = submit || submitFlag[key];
            })
            Object.keys(validRequest).forEach(key => {
                changes = changes || validRequest[key];
            })
        }
        setUpdateDetail((oldValue) => {
            return { ...oldValue, entity: { ...oldValue.entity, NoActiveRelation: checkRelationRank() || false , NoActiveAddress: checkAddressRank()|| false}}})

          //we are cheching that identifier is submitted or not also checking that all input fields have value or not
          if (noIdentifierData) {
            setModalOpen({
                flag: true,
                success: false,
                message: errorMessage[0].noDataInIdentifier.description,
                title: errorMessage[0].noDataInIdentifier.heading
            })
            } else if (identifierSubmit) {
            setModalOpen({
                flag: true,
                success: false,
                message: errorMessage[0].saveDataInIdentifier.description,
                title: errorMessage[0].saveDataInIdentifier.heading
            })
            } else if (submit === true && changes === true) {
            setModalOpen({
                flag: true,
                success: false,
                message: errorMessage[0].addAllInputData.description,
                title: errorMessage[0].addAllInputData.heading
            })
            } else if (submit === false && changes === false && editable.includes('Edit')) {                
            setModalOpen({
                flag: true,
                success: false,
                message: errorMessage[0].addChanges.description,
                title: errorMessage[0].addChanges.heading
            })
            }else if(data.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(checkSource(detail.entity.Source)[0].value) && entity == 'HCO' && addressDeactivationValidation()){
                setModalOpen({
                    flag: true,
                    success: false,
                    message: !showAddressDeactivationMessage ? errorMessage[0].checkAddressRank.description : errorMessage[0].checkAddressRank.description1,
                    title: errorMessage[0].checkAddressRank.heading,
                    showConfirmationButton: showConfirmationButtonn || false
                })
            }else if(data.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(checkSource(detail.entity.Source)[0].value) && entity == 'HCP' &&  checkSpecialtyRank()){
                setModalOpen({
                    flag: true,
                    success: false,
                    message: showConfirmationButtonn ?  errorMessage[0].checkSpecialtyRank.description : errorMessage[0].checkSpecialtyRank.description1,
                    title: errorMessage[0].checkSpecialtyRank.heading,
                    showConfirmationButton: showConfirmationButtonn || false
                })                
            }else if(data.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(checkSource(detail.entity.Source)[0].value) && entity == 'HCP' && checkRelationRank()){
                setModalOpen({
                    flag: true,
                    success: false,
                    message: showConfirmationButtonn ?  errorMessage[0].checkRelationRank.description : errorMessage[0].checkRelationRank.description1,
                    title: errorMessage[0].checkRelationRank.heading,
                    showConfirmationButton: showConfirmationButtonn || false
                })                
            }
            else {                
                setModalOpen({
                    flag: true,
                    message: 'Comments *',
                    success: true,
                    title: errorMessage[0].submitRequest.heading
                })
                setShowError(false)
                }

           
    }
     /**
     * Back to Result page
     */
    const goBack = () => {
        props.history.push('/')
    }
    /**
     * body creation for DCR
     * @param {*} value : value of changes attribute
     * @param {*} name : name of attribute
     * @param {*} array : value is array type flag
     * @param {*} flag : valid value flag
     */
    const updatedValue = async (value, name, array, flag, inputFieldName, index, editCancelIndex) => {
        if (data.ORIGINAL_VALUE_LIST.includes(name) && (detail.entity.Source.every((el)=> data.LILLY_MANAGED_SOURCES.includes(el.value)) || detail.entity.Source.every((el)=> data.OPEN_DATA_SOURCES.includes(el.value)))) {
            let EditAddressIndex;             
            let AddedAddressIndex;
            if(inputFieldName){
                AddedAddressIndex = value.findIndex((res)=> res['SourceAddressId'][0].value ===  detail?.entity[name][index]['SourceAddressId'][0].value)
            }            
            if(originalValue.Address && editCancelIndex == undefined && index != undefined){
                EditAddressIndex = Object.values(originalValue.Address).findIndex((res)=> res['SourceAddressId'][0].value ==  detail?.entity[name][index]['SourceAddressId'][0].value)
            }                           
            if (
                detail.entity[name] != undefined &&
                name != 'Address' &&
                name != 'Prefix' &&
                name != 'ClassificationCode' &&
                name != 'SubClassificationCode' &&
                name != 'NewIdentifiers' &&
                !index &&
                !inputFieldName &&
                value?.value != detail?.entity[name][0]?.value
            ) {
                setOriginalValue({ ...originalValue, [name]: detail.entity[name] })
            } else if (
                detail.entity[name] != undefined &&                
                (name == 'Prefix' || 'ClassificationCode' || 'SubClassificationCode') &&

                value?.value?.split(' | ')[0]?.toLowerCase() !=
                detail?.entity[name][0]?.value?.toLowerCase() &&
                value?.value?.split(' | ')[1] != detail?.entity[name][0]?.lookupRawValue
            ) {
                setOriginalValue({ ...originalValue, [name]: detail.entity[name] })
            }else if(name == 'NewIdentifiers'){                
                let filteredValue =  value.filter((res)=> res.Deactivated == true)             
                if(filteredValue.length > 0){                    
                    setOriginalValue(prevOriginalValue => ({
                        ...prevOriginalValue,
                        NewIdentifiers: [
                            ...(prevOriginalValue.NewIdentifiers || []),
                            detail.entity?.Identifiers?.[index] || null
                        ]
                    }));
                }              
            }            
            else {
                if (
                name == 'Address' &&
                value != undefined &&                
                inputFieldName != undefined &&
                inputFieldName != 'ActiveFlag' &&
                index != undefined                
                ) {
                    if((EditAddressIndex == undefined || EditAddressIndex == -1) &&
                        ((detail?.entity[name][index][inputFieldName]?.[0]?.value !== value[AddedAddressIndex][inputFieldName]?.[0]?.value )
                        )){
                    setOriginalValue((prevState) => {
                        const address = prevState?.Address || []
                        const addressItem = address[EditAddressIndex]  || {}
                        const newValue = detail?.entity?.[name]?.[index]?.[inputFieldName];
                                const updatedAddressItem = {
                                    ...addressItem,
                                    [inputFieldName]: newValue,
                                    ['SourceAddressId']: detail?.entity?.[name]?.[index]?.['SourceAddressId']  // Update the specific field with the new value
                                };
                                return {
                                    ...prevState, // Preserve the previous state
                                    Address: {
                                        // Update the first item in the array
                                        ...address,
                                        [AddedAddressIndex]: updatedAddressItem // Keep the rest of the items
                                    }
                                };
                            });  

                    }else if((EditAddressIndex != undefined || EditAddressIndex != -1) &&
                    ((detail?.entity[name][index][inputFieldName]?.[0]?.value !== value[AddedAddressIndex][inputFieldName]?.[0]?.value )
                        )){
                        setOriginalValue((prevState) => {
                            const address = prevState.Address || {}
                            const addressItem = prevState.Address[EditAddressIndex]  || {}
                            const newValue = detail?.entity?.[name]?.[index]?.[inputFieldName];
                            const updatedAddressItem = {
                                ...addressItem, // Preserve existing data
                                [inputFieldName]: newValue,
                                ['SourceAddressId']: detail?.entity?.[name]?.[index]?.['SourceAddressId']   // Update the specific field with the new value
                            };
                
                            return {
                                ...prevState, // Preserve the previous state
                                Address: {
                                    // Update the first item in the array
                                    ...address,
                                    [AddedAddressIndex]: updatedAddressItem // Keep the rest of the items
                                }
                            };
                        });                            
                    }  
                }             
            }
            if (
                name != 'Address' &&
                name != 'Prefix' &&
                detail.entity[name] &&
                value?.value == detail?.entity[name][0]?.value &&
                originalValue &&
                originalValue[name]
            ) {
                delete originalValue[name]
            } else if (
                (name == 'Prefix' || 'ClassificationCode' || 'SubClassificationCode') &&
                name != 'Address' &&
                detail.entity[name] &&
                value?.value?.split(' | ')[0]?.toLowerCase() ==
                detail?.entity[name][0]?.value?.toLowerCase() &&
                value?.value?.split(' | ')[1] == detail?.entity[name][0]?.lookupRawValue &&
                originalValue &&
                originalValue[name]
            ) {
                delete originalValue[name]
            }
            else if (
                name ==
                'Address' &&
                value != undefined &&
                inputFieldName != undefined &&
                inputFieldName != 'ActiveFlag' &&
                index != undefined &&
                EditAddressIndex != undefined && 
                (detail?.entity[name][index][inputFieldName]?.[0]?.value == value[AddedAddressIndex][inputFieldName]?.[0]?.value) &&
                originalValue && originalValue.Address[EditAddressIndex][inputFieldName]
            ) { 
                if(Object.keys(originalValue.Address[EditAddressIndex]).length == 2 && Object.keys(originalValue.Address).length == 1){
                    delete originalValue[name]
                }
                else if(Object.keys(originalValue.Address[EditAddressIndex]).length == 2 && Object.keys(originalValue.Address).length > 1){
                     delete originalValue.Address[EditAddressIndex]
                }
                else{
                     delete originalValue.Address[EditAddressIndex][inputFieldName]
                }              
            } 
            else if(name == 'Address' &&
               editCancelIndex != undefined)
            {
                if(originalValue && originalValue.Address){
                    let deleteAddressIndex = Object.values(originalValue.Address).filter((res)=> res['SourceAddressId'][0].value !=  detail?.entity[name][editCancelIndex]['SourceAddressId'][0].value)
                    setOriginalValue({...originalValue,  Address: deleteAddressIndex})                   
                }   
            }
            else if(name == 'NewIdentifiers' && index!= undefined && !value[index]['Deactivated']){
                if(originalValue && originalValue['NewIdentifiers'] ){
                    let filteredValue =  value[index]                    
                    setOriginalValue({...originalValue,  NewIdentifiers: originalValue['NewIdentifiers'].filter((res)=> res.uri != filteredValue.uri )})     
        }
            }
        }
        // --------------------------------------------------------------------------
        if (name === "NewIdentifiers"){
            setSubmitFlag((oldValue) => {
                return { ...oldValue, [name]: false }
            });
        }
        else
        setSubmitFlag((oldValue) => {
            return { ...oldValue, [name]: flag }
        });
        /*
        Code to check if ant change is taken place
        */
        if (!CONSTANT.ADD_NEW_ATTRIBUTE.includes(name)) {
            let oldValue = detail?.entity[name];
            if (((oldValue === undefined &&
                (value.value !== null && value?.value?.length !== 0)) ||
                (oldValue !== undefined && oldValue[0]?.value !== value?.value)) &&
                (name !== 'Address')
            ) {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: true
                    }
                })
            } else if (name === 'Address') {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: (value.length !== 0)
                    }
                })
            } else {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: false
                    }
                })
                delete updateDetails.entity[name];
                if(name !== 'ActiveFlag') 
                    value = undefined;

            }
        } else if (name === 'NewSpecialities') {
            if (value !== undefined && ((value.PrimarySpecialty !== undefined && value.PrimarySpecialty[0].value !== null && value.PrimarySpecialty[0].value.length > 0) || (value.OtherSpecialty !== undefined && value.OtherSpecialty[0].value !== null && value.OtherSpecialty[0].value.length > 0))) {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: true
                    }
                })
            } else {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: false
                    }
                })
                delete updateDetails.entity[name];
                specialtyList !==  undefined && delete specialtyList[name]
                value = undefined;
            }
        }
        else if (name === 'Specialities') {
            if (value !== undefined) {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: true
                    }
                })
            }
            else {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: false
                    }
                })
                value = undefined;                
            }
        }

        else if (name === 'NewIdentifiers') {
            if (value !== undefined && value.filter((el)=>{return el.AddedNew === true}).length > 0) {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: true
                    }
                })
            } else if(value !== undefined && value.filter((el)=>{return el.Deactivated != undefined}).length > 0){
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: true
                    }
                })
            }else {
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: false
                    }
                })
                // delete updateDetails.entity[name];
                // value = undefined;
            }
        }

         else if (name === 'AddAddress') {
            if (value === undefined) {
                delete submitFlag[name];
                delete validRequest[name]
            } else {
                setValidRequest((oldValue) => ({ ...oldValue, [name]: true }))
            }
        } else {
            let changeFlag;
            if (value === undefined) {
                changeFlag = flag;
            } else {
                if (name === 'Relation') {
                    changeFlag = !flag;
                } else {
                    let oldSpeciality = detail.entity.Specialities;
                    if (oldSpeciality === undefined && value === undefined) {
                        changeFlag = false;
                    } else if (oldSpeciality === undefined && value !== undefined) {
                        changeFlag = true;
                    } else {
                        changeFlag = oldSpeciality.length === value.length;
                    }
                }
            }

            
            if(name === 'Relation' && detail?.entity?.Source[0]?.value === 'VNDR-VOD' && flag == true){
                setValidRequest((old) => {
                    return {
                        ...old,
                        [name]: changeFlag,
                        "RelationType": changeFlag
                    }

                })
                setSubmitFlag((old) => {
                    return {
                        ...old,
                        "RelationType": changeFlag
                    }
                })
            }else{
                setValidRequest((old) => {
                                return {
                                    ...old,
                                    [name]: changeFlag
                                }
                            })
            }
        }

        /*
        Constructing the updated body
        */
        if (value !== undefined) {
            if (array === undefined) {
                if (name === 'ActiveFlag') {
                    if (
                        detail.entity.ActiveFlag
                        && detail.entity.ActiveFlag.length > 0
                        && detail.entity.ActiveFlag[0].value === 'Y'
                        && value.value === 'N'
                    ) {
                        await setUpdateDetail((oldValue) => {
                            return {
                                ...oldValue,
                                entity: {
                                    ...oldValue.entity,
                                    [name]: [value],
                                    EffectiveStartDate: detail.entity.EffectiveStartDate,
                                    EffectiveEndDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                                }
                            }
                        });
                    } else if (
                        detail.entity.ActiveFlag
                        && detail.entity.ActiveFlag.length > 0
                        && detail.entity.ActiveFlag[0].value === 'N'
                        && value.value === 'Y'
                    ) {

                        await setUpdateDetail((oldValue) => {
                            return {
                                ...oldValue,
                                entity: {
                                    ...oldValue.entity,
                                    [name]: [value],
                                    EffectiveStartDate: detail.entity.EffectiveStartDate,
                                    EffectiveEndDate: [{ value: "9999-12-31" }],
                                }
                            }
                        });
                    } else {

                        delete updateDetails.entity[name];
                        delete updateDetails.entity.EffectiveStartDate;
                        delete updateDetails.entity.EffectiveEndDate;
                    }

                } else {

                    await setUpdateDetail((oldValue) => {
                        return {
                            ...oldValue,
                            entity: {
                                ...oldValue.entity,
                                [name]: [value]
                            }
                        }
                    });
                }

            } else if (name === 'Address') {
                await setUpdateDetail((oldValue) => {
                    return {
                        ...oldValue,
                        entity: {
                            ...oldValue.entity,
                            [name]: value
                        }
                    }
                });
            } else if (name === 'Specialities') {         

                if(value[0].isDeleted == true){
                    let previousData = updateDetails?.entity?.Specialities || [] 
                    let existingIndex = previousData.findIndex((res)=> res.uri == value[0].uri)
                    if(existingIndex != -1){
                        updateDetails.entity[name][existingIndex] = value[0]
                        specialtyList[name][existingIndex] = value[0]
                       
                    }else{
                    await setUpdateDetail((oldValue) => {
                        return {
                            ...oldValue,
                            entity: {
                                ...oldValue.entity,
                                [name]: [...previousData ,...value]
                            }
                        }
                    });
                     await setSpecialtyList((oldValue) => {
                        return {
                            ...oldValue,
                            [name]: [...previousData ,...value]
                        }
                    });
                    await setShowAllSpecialty((oldValue) => {
                        return {
                            ...oldValue,
                            [name]: [...previousData,...value]
                        }
                    });
                }                   

                }else if(value[0].isDeleted == false){   
                    await setUpdateDetail((oldValue) => {
                        return {
                            ...oldValue,
                            entity: {
                                ...oldValue.entity,
                                [name]: updateDetails?.entity?.Specialities.filter((res)=> res.uri != value[0].uri)
                            }
                        }
                    });
                    await setSpecialtyList((oldValue) => {
                        return {
                            ...oldValue,
                                [name]: updateDetails?.entity?.Specialities.filter((res)=> res.uri != value[0].uri)
                        }
                    });
                    await setShowAllSpecialty((oldValue) => {
                        return {
                            ...oldValue,
                            [name]: [...updateDetails?.entity?.Specialities.filter((res)=> res.uri != value[0].uri) ,...value]
                        }
                    });

                }
                
            } 
            else if (name === 'Relation') {
                if (value === undefined) {
                    await setUpdateDetail((oldValue) => {
                        return {
                            ...oldValue,
                            relations: updateDetails.relations.filter((res)=>{
                                return res.IsStatusChanged 
                            }
                            )
                        }
                    });
                } else {

                    if (value?.HCO?._source !== undefined) {
                        if (updateDetails.relations.length > 0 && updateDetails.relations.filter((res)=> res.uri === value.HCO._id).length > 0) {
                            let filteredNonprimaryRelation = updateDetails.relations.findIndex((res)=> res.uri === value.HCO._id)
                            // Ensure filteredNonprimaryRelation has a valid index
                            if (filteredNonprimaryRelation !== -1) {
                                await setUpdateDetail((oldValue) => {
                                    const updatedRelations = [...oldValue.relations];
                                    updatedRelations[filteredNonprimaryRelation] = { ...updatedRelations[filteredNonprimaryRelation],  IsPrimary: value['IsPrimary'], Rank: value['Rank'], relationTypeCode: value?.relationTypeCode !== undefined ? value.relationTypeCode?.value: undefined };
                                    return {
                                        ...oldValue,
                                        relations: updatedRelations
                                    };
                                });
                            }
                        }
                        else{


                            // First, check if there's any existing relation with IsNew === true
                            const existingIndex = updateDetails.relations.findIndex(rel => rel.IsNew === true);

                            if (existingIndex !== -1) {
                                // If found, remove it
                                updateDetails.relations.splice(existingIndex, 1);
                            }

                            // updateDetails
                                updateDetails.relations.push({
                                    uri: value.HCO._id,
                                    type: value.HCO._source.type,
                                    label: value.HCO._source.label,
                                    Rank: value.Rank,
                                    EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                                    EffectiveEndDate: [{ value: "9999-12-31" }],
                                    Source: value.HCO._source.Source,
                                    DepartmentIndicator: value.HCO._source.DepartmentIndicator,
                                    IsPrimary: value['IsPrimary'],
                                    IsNew: true,
                                    relationTypeCode : value?.relationTypeCode !== undefined ?? value?.relationTypeCode?.value
                                })
                        }          
                        
                        if(detail?.entity?.Source[0]?.value === 'VNDR-VOD' && value?.relationTypeCode !== undefined){
                            setSubmitFlag((old) => {
                                return {
                                    ...old,
                                    "RelationType": false
                                }
                            })
                        }
                    } else if(value.IsStatusChanged !== undefined){
                        if(value.IsStatusChanged){            
                            await setUpdateDetail((oldValue) => {
                                return {
                                    ...oldValue,
                                    relations: [...oldValue.relations,{...value}]
                                }
                            })
                        }else{     
                            await setUpdateDetail((oldValue) => {
                                return {
                                    ...oldValue,
                                    relations: updateDetails.relations.filter((res)=>{
                                        return res.uri !== value.uri
                                    }
                                    )
                                }
                            })       
                            if(updateDetails && updateDetails.relation && updateDetails.relations.filter((res)=>{
                                return res.uri !== value.uri}).length == 0){  
                                    let submitObj = submitFlag;
                                    let validRequestObj = validRequest;                                     
                                    let { Relation, ...newSubmitObj } = submitObj;
                                    let { Relation: _, ...newvalidObj } = validRequestObj;
                                    setSubmitFlag(newSubmitObj);
                                    setValidRequest(newvalidObj);                                  
                                }                            
                            }
                        } 
                    else {
                        // if (updateDetails.relations.length > 0) {
                        //     updateDetails.relations.splice(0, updateDetails.relations.length);
                        // }
                        const { AddressLine1, City, Zip, StateProvince, Country, ClassificationCode, Rank, IsPrimary, RelationTypeCode } = value;    
                        
                        if(updateDetails.relations.length > 0 && updateDetails.relations.some((res)=> res.IsNew)){  
                            let filteredNonprimaryRelation = updateDetails.relations.findIndex((res)=> res.IsNew === true)
                            // Ensure filteredNonprimaryRelation has a valid index
                            if (filteredNonprimaryRelation !== -1) {
                                await setUpdateDetail((oldValue) => {
                                    const updatedRelations = [...oldValue.relations];
                                    updatedRelations[filteredNonprimaryRelation] = { ...updatedRelations[filteredNonprimaryRelation],  IsPrimary: value['IsPrimary'], Rank: value['Rank'] };
                                    return {
                                        ...oldValue,
                                        relations: updatedRelations
                                    };
                                });
                            }
                        } else{
                        updateDetails.relations.push({
                            Name: value.HCO, Country, Rank, ClassificationCode, IsPrimary,
                            EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                            EffectiveEndDate: [{ value: "9999-12-31" }],
                            ActiveFlag: [{ value: 'Y' }],
                            Address: [{
                                AddressLine1, City, Zip, StateProvince, Country,
                                Rank: [{ value: '1' }],
                                EffectiveStartDate: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
                                EffectiveEndDate: [{ value: "9999-12-31" }],
                            }],
                            Source: detail.entity.Source,
                            IsNew: true,
                            relationTypeCode: RelationTypeCode !== undefined ? RelationTypeCode[0].value : undefined
                        });
                        }

                        if(detail?.entity?.Source[0]?.value === 'VNDR-VOD' && RelationTypeCode !== undefined){
                            setSubmitFlag((old) => {
                                return {
                                    ...old,
                                    "RelationType": false
                                }
                            })
                        }
                    }
                    
                    // if (
                    //     value.Rank &&
                    //     value.Rank[0]["value"] == 1 &&
                    //     value["IsPrimary"]
                    //   ) {
                    //     if(detail.relations != undefined && Object.keys(detail.relations).length > 0 ){
                    //         var updatedRelation = filterRealtions(detail.relations);
                    //     }
                    //     if(detail.entity.Address != undefined && Object.keys(detail.entity.Address).length > 0 ){
                    //         var updatedAddress = filterAddress(
                    //             detail.entity.Address
                    //           );
                    //     }                 
                       
                    //     if (updatedAddress && updatedAddress.length > 0 ) {
                    //       await setUpdateDetail((oldValue) => {
                    //         return {
                    //           ...oldValue,
                    //           entity: {
                    //             ...oldValue.entity,
                    //             Address: updatedAddress,
                    //           }                          
                    //         };
                    //       });
                    //     }

                    //     // if (updatedRelation) {
                    //     //   await setUpdateDetail((oldValue) => {
                    //     //     return {
                    //     //       ...oldValue,                              
                    //     //       relations:[
                    //     //         ...oldValue.relations,
                    //     //         ...updatedRelation
                    //     //     ]                            
                    //     //     };
                    //     //   });
                    //     // }
                                            
                    //   }
                    //   else {
                    //      // delete updateDetails.entity.Address
                    //       delete updateDetails.secondaryAffiliation
                    //   }

                }
            } else {
                //old value updates but keeps getting rewritten with the last value that was updated.
                setSpecialtyList((oldValue)=>{
                    return {
                        ...oldValue,
                        [name]: value
                    }
                })
                setShowAllSpecialty((oldValue)=>{
                    return {
                        ...oldValue,
                        [name]: value   
                    }
                })
                await setUpdateDetail((oldValue) => {
                    return {
                        ...oldValue,
                        entity: {
                            ...oldValue.entity,
                            [name]: value
                        }
                    }
                });
            }
        } else {
            if (name === 'NewSpecialities' || name === 'AddAddress') {
                delete updateDetails.entity[name];
                if(name === 'NewSpecialities'){
                    setShowAllSpecialty((oldValue)=>{
                        let updatedShowAllSpecialty = {...oldValue}
                        delete updatedShowAllSpecialty[name]
                        return updatedShowAllSpecialty
                    })
                }
            } else {
                await setUpdateDetail((oldValue) => {
                    return {
                        ...oldValue,
                        relations: updateDetails.relations.filter((res)=>{
                            return res.IsStatusChanged 
                        }
                        )
                    }
                });
              
            }
        }
    }

    /**
     * Handel add Relation and Delete Relation
     * @param {*} operation : type of action
     */
    const addRelationObject = (operation) => {
        if (operation === 'add') {
            updatedValue(undefined, 'Relation', true, true);
        } else {
            updatedValue(undefined, 'Relation', true, false);
        }
    }


    //function to merge specility and new speciality section into single list for UI
    const transformSpecialityList = (specialityList) =>{
        const transformedList = []
        
        if(specialityList['NewSpecialities'] && Object.keys(specialityList['NewSpecialities']).length > 0){
            const {OtherSpecialty, ...rest} = specialityList['NewSpecialities']
            OtherSpecialty && specialityList['NewSpecialities']['OtherSpecialty'][0]['value'].map(item=>{
                transformedList.push({
                    ...rest,
                    Specialty: [{value: item}]
                })
            })

        }
        if(specialityList['Specialities']){
            specialityList['Specialities'].map((item)=>{
                if(item['Replacement'] !== undefined && item['isDeleted'] == true){
                    const {PrimarySpecialty, OtherSpecialty , ...rest} = item['Replacement']
                    PrimarySpecialty ? PrimarySpecialty.map(splt =>{
                        transformedList.push({
                            ...rest,
                            Specialty:[{value: splt['value']}]
                        })
                    }) : 
                    OtherSpecialty.map(splt =>{
                        transformedList.push({
                            ...rest,
                            Specialty: Array.isArray(splt['value']) ? [{value: splt['value'][0]}] : [{value: splt['value']}]
                        })
                    })
                }
                transformedList.push(item)                
            })
        }
    return transformedList
    }

    //function for filter relation and make it rank 99
    // const filterRealtions = (relationValue) => {

    //     let relation = relationValue
    //       .map((item) => {
    //         let filteredClassifications = item.AffiliationClassification.filter(
    //           (classification) =>
    //             classification.Rank && classification.Source && classification.Rank[0].value == "1" &&
    //             (data.PRIMARY_AFFILIATION_ALLOWED_SOURCES_.includes(classification.Source[0].value))
    //         );
    //         if (filteredClassifications.length > 0) {
    //           return {                
    //             crosswalks: item['crosswalks'], 
    //             AffiliationClassification: filteredClassifications,
    //             startObject: item['startObject'],
    //             endObject: item['endObject'],
    //             type: item['type']
    //           };
    //         }

    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     let updateRank = [...relation];

    //     for (let index = 0; index < updateRank.length; index++) {
    //       if (updateRank[index]["AffiliationClassification"].length > 0) {
    //         updateRank[index]["AffiliationClassification"] = updateRank[index][
    //           "AffiliationClassification"
    //         ].map((res) => {
    //           return {
    //             Source: res['Source'] ,
    //             ActiveFlag: res['ActiveFlag'],
    //             RelationshipTypeCode: res['RelationshipTypeCode'],
    //             Rank: [{ value: "99" }]
    //           };
    //         });
    //       }
    //     }           
    //   return updateRank

    // }

    // function for filtering address and making them to rank 99
    // const filterAddress = (addressData) => {
    //     let filteredAddress = Object.values(addressData).filter(
    //       (res) => res.Rank && res.Rank[0]["value"] == 1
    //     );
    //     filteredAddress = filteredAddress.map((res) => {
    //       return {
    //         ...res,
    //         Rank: [{ value: "99" }],
    //       };
    //     });

    //    return filteredAddress;
      
    // }

    // added function for identifier saved or delet
    const checkIdentifierSubmitted = (addflag, identifierType,identifierId,identifierSaved)=>{               
              
        if(addflag && (((identifierType?.length == 0) && (identifierId?.length == 0 )) || ((identifierType == undefined) && (identifierId == undefined ) )) && identifierSaved == false)
        {
            
         setNoIdentifierData(true)
         setIdentifierSubmit(false)
        }
        else if(addflag && identifierType?.length > 0 && identifierId?.length > 0  && identifierSaved == false)
        {

        setIdentifierSubmit(true)
        setNoIdentifierData(false)

        }
      
        else{

        setIdentifierSubmit(false)
        setNoIdentifierData(false)
        }
      

    }

    /**
     * Disable edit icon for realtion after reaching maximum count of deactiavtion
     */
    const disableEditIcon = (editFlag, i) =>{
        setAddressEditIndex({...addressEditIndex, [i]: editFlag})
    }

    const openSpecialtyModal = (value) => {
        setSpecialtyDataSaved(value)
        setShowSpecialtyPopup(!showSpecialtyPopup)
    }



    /**
     * After Submission Of DCR
     */
    const submitted = async () => {
        await changeOperation({ target: { value: 'Viewing' } });
        setModalOpen({ flag: false });
        setShowError(false);
        setNewRelation(false);
        setChangeCompleted(true);
        window.location.reload();
        let intervalId = setTimeout(() => {
            setChangeCompleted(false);
            clearTimeout(intervalId)
        }, 1000)
        entity == 'HCP' ?
        await setUpdateDetail({
            entity: {
                label: JSON.parse(JSON.stringify(detail.entity.label ? detail.entity.label : '')),                
                uri: JSON.parse(JSON.stringify(detail.entity.uri ? detail.entity.uri : '')),
                type: JSON.parse(JSON.stringify(detail.entity.type ? detail.entity.type : '')),
                CountryCode: JSON.parse(JSON.stringify(detail.entity.CountryCode ? detail.entity.CountryCode : '')),
                Source: checkSource(JSON.parse(JSON.stringify(detail.entity.Source ? detail.entity.Source : undefined))),
                OriginalSource: JSON.parse(JSON.stringify(detail.entity.OriginalSource ? detail.entity.OriginalSource : '')),
                Specialities: JSON.parse(JSON.stringify(detail.entity.Specialities ? detail.entity.Specialities : '')),
                Identifiers: JSON.parse(JSON.stringify(detail.entity.Identifiers ? detail.entity.Identifiers : '')),
            }, relations: []
        }) :
        await setUpdateDetail({
            entity: {
                label: JSON.parse(JSON.stringify(detail.entity.label ? detail.entity.label : '')),
                Name: JSON.parse(JSON.stringify(detail.entity.Name ? detail.entity.Name : '')),
                uri: JSON.parse(JSON.stringify(detail.entity.uri ? detail.entity.uri : '')),
                type: JSON.parse(JSON.stringify(detail.entity.type ? detail.entity.type : '')),
                CountryCode: JSON.parse(JSON.stringify(detail.entity.CountryCode ? detail.entity.CountryCode : '')),
                Source: checkSource(JSON.parse(JSON.stringify(detail.entity.Source ? detail.entity.Source : undefined))),
                OriginalSource: JSON.parse(JSON.stringify(detail.entity.OriginalSource ? detail.entity.OriginalSource : '')),
                Specialities: JSON.parse(JSON.stringify(detail.entity.Specialities ? detail.entity.Specialities : '')),
                Identifiers: JSON.parse(JSON.stringify(detail.entity.Identifiers ? detail.entity.Identifiers : '')),
            }, relations: []
        });
    }
    /**
     * Show More Action
     */
    const showMore = () => {        
        setIndexView(indexView + CONSTANT.SHOW_VALUE_INCREMENT);
        if (indexView + CONSTANT.SHOW_VALUE_INCREMENT < allRelation.length) {
            setRelationData(allRelation.slice(0, indexView + CONSTANT.SHOW_VALUE_INCREMENT))
        } else {
            setRelationData(allRelation)
        }
        
    }

    /**
     * Show Less Action
     */
    const showLess = () => {        
        setIndexView(CONSTANT.SHOW_VALUE_NUMBER);
        setRelationData(allRelation.slice(0, CONSTANT.SHOW_VALUE_NUMBER))
    }

    /**
     * Filter the Nested Atrribute
     * @param {*} term : text value
     */
    const filterRelationTerm = (term) => {
        if (term.length === 0) {
            setAllRelation(relationsAfterFiltering)
            setRelationData(relationsAfterFiltering.slice(0, CONSTANT.SHOW_VALUE_NUMBER))
        } else {
            let normalrelation = allRelation;
            let filteredRelation = normalrelation.filter((value) => {
                let relationName;
                if (value.startObject.objectURI.split('/')[1] !== id) {
                    relationName = value.startObject.label;
                } else {
                    relationName = value.endObject.label;
                }
                return (relationName !== undefined ? relationName.toLowerCase().includes(term.toLowerCase()) : false)
            });
            setAllRelation(filteredRelation)
            setRelationData(filteredRelation.slice(0, CONSTANT.SHOW_VALUE_NUMBER))
        }
    }

    /**
     * mapping Response
     * @param {*} value 
     * @returns mapped Response
     */
    const mapResponse = (value, id) => {
        if (value === undefined) {
            return value;
        } else {
            if(id == 'Address' && data.ALLOWED_SOURCE_FOR_DEACTIVATION.includes(checkSource(detail.entity.Source)[0].value)){
                let todayDate =  moment.utc(new Date()).format("YYYY-MM-DD")    
                return (value.length > 0 ? value.map(item => {
                    // Check if the EffectiveEndDate attribute is present
                    if (item.hasOwnProperty("EffectiveEndDate")) {                        
                      return {
                        ...item,  
                        ActiveFlag: [{value: item.EffectiveEndDate[0].value <= todayDate ? 'N' : 'Y'  }]  
                      };
                    }
                    return item;  // Return the object unchanged if EffectiveEndDate is not present
                  }) : undefined)
            }
            else{
                return (value.length > 0 ? value : undefined)
            }
            
        }
    }

    /**
     * Map Editable Attribute
     * @param {*} value 
     * @returns mapped Value
     */
    const mapEditableAttributes = (value) => {
        if (value === undefined || [1].includes(value.length) || !editable.includes('Edit')) {
            return value;
        } else if (value !== undefined && value.length === 0) {
            return undefined;
        } else {
            return [value[0]];
        }
    }

    const getCodeBased =(res)=>{       

    let multiCountryData = res.map((response)=> 
    {
       const filterCountry = CountryCodeBase.find((el)=> el.country_Name === response.value )
       return {...response,codeBase: filterCountry ? filterCountry.codeBase :''}
    }).filter((e)=> e.codeBase != "")

    
    if(multiCountryData.length > 1){
        let sameCodeBase = multiCountryData.every((el)=> el?.codeBase === multiCountryData[0].codeBase )
        return sameCodeBase 
    }
    else{
        return false
    }
             
    }


    useEffect(() => {
        async function fetchDetails() {
            await api.getUserDetails(id, entity, CONSTANT.COMMERCIAL_USER).then((res) => {                        
                let detailJSON = res;
                setcountryData(detailJSON.data.entity.CountryCode[0].value);
                let hcpEditableFlagValue = get(detailJSON.data.entity.CountryCode[0].value, detailJSON.data.entity.Source);                
                setDetail(detailJSON.data);
                setSourceData(detailJSON.data.entity.Source)
                let entityValue = detailJSON.data.entity.type ? detailJSON.data.entity.type.split('/')[2] : '';                
                setSpecialtyEdit(checkSource(detailJSON.data.entity.Source)[0].value == 'MNGD-AFF'  ? true : (entityValue === 'HCP' ? true : false));
                setType((entityValue === 'HCP') ? true : false)
                entity == 'HCP' ? 
                setUpdateDetail({
                    entity: {
                        label: detailJSON.data.entity.label,
                        uri: detailJSON.data.entity.uri,                        
                        type: detailJSON.data.entity.type,
                        CountryCode: detailJSON.data.entity.CountryCode,
                        NewIdentifiers: detailJSON.data.entity.Identifiers || [],
                        Source: checkSource(detailJSON.data.entity.Source),
                        OriginalSource: detailJSON.data.entity.OriginalSource,
                        Specialities: detailJSON.data.entity.Specialities
                    }
                    , relations: []
                }) :
                setUpdateDetail({
                    entity: {
                        label: detailJSON.data.entity.label,
                        uri: detailJSON.data.entity.uri,
                        Name: detailJSON.data.entity.Name,
                        type: detailJSON.data.entity.type,
                        CountryCode: detailJSON.data.entity.CountryCode,
                        NewIdentifiers: detailJSON.data.entity.Identifiers || [],
                        Source: checkSource(detailJSON.data.entity.Source),
                        OriginalSource: detailJSON.data.entity.OriginalSource,
                        Specialities: detailJSON.data.entity.Specialities
                    }
                    , relations: []
                })
                setSpecialtyList({Specialities: detailJSON.data.entity.Specialities})
                setShowAllSpecialty({Specialities: detailJSON.data.entity.Specialities, NewSpecialities: []})

                let multiCountrySourced = detailJSON.data.entity.Source.every((el)=> data.MULTI_COUNTRY_ALLOWED_SOURCES.includes(el.value) )
                             
                if(detailJSON.data.entity.CountryCode.length > 1){

                   (multiCountrySourced && getCodeBased(detailJSON.data.entity.CountryCode) ?  setDropDownOptionsFlag(true) : setDropDownOptionsFlag(false)
                )   
                }
               
                else{    
                    // logic for showing dropdown for edit and view option    
                    // added object 'HCO_EDITABLE_SOURCES' for hco editable sources
                    // added object 'EDITABLE_SOURCES' for hcp editable sources
                    // added object 'EDIT_DISABLED_COUNTRIES' to get disable edit for specific countries

                    setDropDownOptionsFlag(
                        (
                        (Object.keys(detailJSON?.data?.entity?.crosswalks).length == 1 &&
                        detailJSON?.data?.entity?.crosswalks[0]?.sourceTable == `CODS.${entityValue}`
                        ) ||
                        detailJSON.data.entity.Source.every((obj) =>
                            data.EDITABLE_SOURCES.includes(obj.value)
                        ) ||
                        (
                            detailJSON.data.entity.Source.some((obj) =>
                            data.HCO_EDITABLE_SOURCES.includes(obj.value)
                            ) && entityValue === "HCO"
                        ) ||
                        (
                            detailJSON.data.entity.Source.some((obj) =>
                            data.VENDOR_MANAGED_SOURCES.includes(obj.value)
                            ) && entityValue === "HCP" && hcpEditableFlagValue === false
                        ) ||
                        detailJSON.data.entity.CountryCode.some((obj) =>
                            data.EDIT_DISABLED_COUNTRIES.includes(obj.value)
                        )
                        ) &&
                        (                       
                            detailJSON?.data?.entity?.crosswalks.some((res) =>
                            data.ORIGINAL_SOURCES.includes(res.type.split('/')[2])
                        )
                        )                      

                        ? true
                        : false
                    );    
                    // if country is US, allow edit for hcp and hco
                    if (detailJSON.data.entity.CountryCode[0].value === "United States") {
                      // allow if source has IQVIA_US, VNDR-VN.
                      // This is to disable DCR on Liquidhub/Employer standalone if they are not merged with IQVIA
                      let valid_source = []
                      if (entityValue == "HCP") {
                        valid_source = ["Veeva Network"]
                      }
                      else {
                        valid_source = ["IQVIA_US"]
                      }
                      setDropDownOptionsFlag(detailJSON.data.entity.Source.some(item => valid_source.includes(item.value)))
                    }

                    // dropDownOption((!((detailJSON.data.entity.Source).some(obj => (data.EDITABLE_SOURCES).includes(obj.value))) || ( (detailJSON.data.entity.Source).some(obj => (data.VENDOR_MANAGED_SOURCES).includes(obj.value)) && entityValue === 'HCO') || ( (detailJSON.data.entity.Source).some(obj => (data.VENDOR_MANAGED_SOURCES).includes(obj.value)) && entityValue === 'HCP' && hcpeditableflag === false) || ((detailJSON.data.entity.CountryCode).some(obj => (data.EDIT_DISABLED_COUNTRIES).includes(obj.value)))) ? false : true);
                }
                
                // Logic to filter VNDR-CGDM relation's data
                if (detailJSON?.data?.entity?.OriginalSource && detailJSON?.data?.entity?.OriginalSource[0]?.value === "IQVIA_OUS") {
                    let relation = JSON.parse(JSON.stringify(detailJSON?.data?.relations));
                     filterVNDRCGDMRelatioData = relation?.filter(item => {
                         return item?.AffiliationClassification?.some(classification => {
                            if(classification.Source){
                                return classification.Source.some(source => {
                                    return source.value !== "VNDR-CGDM";
                                })  
                            } 
                            else{
                                return classification
                            }                  
                             
                        });
                    });                  
                    setAllRelation(filterVNDRCGDMRelatioData);
                    setRelationData(filterVNDRCGDMRelatioData.slice(0, indexView));
                    setRelationsAfterFiltering(filterVNDRCGDMRelatioData);
                } else {
                    let relationWithoutFiltering = JSON.parse(JSON.stringify(detailJSON?.data?.relations));                  
                    setAllRelation(relationWithoutFiltering);
                    setRelationData(relationWithoutFiltering.slice(0, indexView));
                    setRelationsAfterFiltering(relationWithoutFiltering);
                }                

                if ((entityValue === 'HCO' && detailJSON.data.dcr_enabled &&
                    detailJSON.data.entity.Address && detailJSON.data.entity.Address.length > 0)) {
                    detailJSON.data.entity.Address = detailJSON.data.entity.Address.map((address) => {
                        return {
                            ...address,
                            AddressLine1: mockUndefined(address.AddressLine1),
                            City: mockUndefined(address.City),
                            StateProvince: mockUndefined(address.StateProvince),
                            Zip: address.Zip ? address.Zip : [{ Zip5: [{ value: undefined }] }]
                        }
                    })
                } 
                setDetail(detailJSON.data);
                setProgressFlag(false);              
                
                
            }).catch((error) => {  
                console.log("error", error)

                if (window.location.hash === '#ecs2') {
                    props.history.push('/NoProfileFound#ecs2');
                    return;
                }
                let errorDetail = error; 
                let msg = ((errorDetail?.response?.status == "403") ||  (errorDetail?.response?.status == "401"))  ? errorMessage[0].multiCountryProfile.description : 'Internal Server Error!';
                setErrorMsg(msg ? msg : 'Internal Server Error!');
                setErrorFlag(true);
            })

        }
        fetchDetails();        
    }, [id, entity])   

    useEffect(()=>{
        window.scrollTo(0, 0);
      },[])

    useEffect(()=>{
        dropDownOption()
    },[dropDownOptionFlag])

    // optional prop drilled to edit components to fetch rdm value for Veeva network from "##_vn" keys
    let vendor = undefined
    if (detail?.entity?.Source && detail?.entity?.Source[0].lookupRawValue) {
      // if we have one crosswalk from Veeva Network, we can use it to determine the vendor as VNDR-VN
      if (detail.entity.Source.find(item => item.lookupRawValue == "VNDR-VN")) {
        vendor = "VNDR-VN"
      }
    }

    // override when country is US and this is Edit HCP
    // because we have to show US HCO from IQVIA_US source.
    let newrelation_source = detail?.entity?.Source[0]?.value
    // load identifiers from Veeva network for US
    let identifierviewparams = {}
    if (detail?.entity?.CountryCode[0]?.value == "United States") {
      newrelation_source = "IQVIA_US"

      const lovBounds = Storage.getLovBoundedList()
        
      if (entity == "HCP" && lovBounds && lovBounds['HCP']['AltIDType']) {
        identifierviewparams = {
          "identifierOptions": lovBounds['HCP']['AltIDType']
        }
      }

      if (entity == "HCO" && lovBounds && lovBounds['HCO']['AltIDType']) {
        identifierviewparams = {
          "identifierOptions": lovBounds['HCO']['AltIDType']
        }
      }
    }

    useEffect(()=>{
        get(countryData, sourceData)
    },[countryData])

    return (
        <div className="container-fluid  min-width w-75 mb-5 body-height extra-margin-top-less">
           
            {
                progressFlag && !errorFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <ProgressBar />
                </div>
            }
            {
                errorFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <Alert severity="error" className='container'>
                        <AlertTitle id='alert-text'>{errorMsg}</AlertTitle>
                        <strong className='link pointer text-primary' id='alert-text' onClick={goBack}>back!</strong>
                    </Alert>
                </div>
            }            
            {
                !progressFlag && typeof(detail) === 'object' && !errorFlag
                &&
                <section className="container mb-5">
                    <Stack
                        alignItems={'center'}
                        justifyContent={'flex-start'}
                        flexDirection={'row'}
                    >
                        <Tooltip disableFocusListener title="Back" id="tltipStrictSearchChckbx">
                            <IconButton aria-label="delete"
                                className="text-danger float-start"
                                onClick={goBack} color="secondary">
                                <ArrowBackIcon sx={{transform:direction==='rtl'?'rotate(180deg)':''}}/>
                            </IconButton>
                        </Tooltip>
                    </Stack>
                    <div className="container row  pt-3 mb-3">
                        <div className="col-2">
                           <ProfileIcon
                                type={detail.entity.type.split('/')[2]}
                                sx={{height:'100px', width: '100px'}}
                                iconSX={{fontSize: '4.5rem'}}
                            />
                        </div>
                        <div className="col-8 mb-3">
                            <Typography variant='subtitle1' className='fw-bold'>{detail.entity.label}</Typography>
                            <p className="mb-1">{detail.entity.secondaryLabel}</p>
                            <Chip label={detail.entity.type.split('/')[2]} size="small" className='mt-0' />
                        </div>
                        <div className="col-2 d-flex justify-content-end">
                            <FormSelect
                                defaultValue={editable.includes('Edit') ? 'Edit' : 'Viewing'}
                                key="viewSelect"
                                name="viewSelect"
                                selectLabel='View'
                                onSelectValue={changeOperation}
                                selectData={controlOption}
                            />
                        </div>
                        <div className="col-12 d-flex justify-content-end">
                            {editable.includes('Edit') && <Button
                                variant="contained"
                                color="error"
                                size="small"
                                id="search-text"
                                className={classes.button}
                                startIcon={<SaveIcon />}
                                onClick={() => changeDetails(detail)}
                            >
                                Request
                                </Button>
                            }
                        </div>
                    </div>
                </section>
                }

                { !progressFlag && typeof(detail) === 'object' && !errorFlag
                    &&  
                // tab layout for consent created
                <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                { entity == 'HCP' && detail?.consent_exists && !editable.includes('Edit') &&
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList    
                    onChange={handleChangeTab}
                    aria-label='lab API tabs example'
                    indicatorColor='primary'
                    textColor='primary'
                >
                    <Tab className='_wg-dynamic-text' label='Profile' value='1'/>                        
                    {entity == 'HCP' && detail?.consent_exists && ( 
                        <Tab                        
                        sx={{maxWidth:'100%'}}
                        value ="2"                                               
                        className='_wg-dynamic-text'
                        label={ 
                            <CustomWidthTooltip title={ consentError ? ((CONSTANT.CONSENTS_ATTEMPTS == consentAttempt) ? errorMessage[0]?.consentErrorAttemptsNotLeft .description : errorMessage[0].consentErrorAttemptsLeft.description):'' } placement="top" id='tooltip'>                                                                    
                            <span>
                                Consents
                                
                                {consentProgressBar && (
                                    <CircularProgress
                                    sx={{ color: '#ce2a1d', marginLeft: '5px', marginTop: 'auto' }}
                                    size={15}
                                    />
                                )}
                                {!consentProgressBar && consentError && (                                    
                                    <span style={{ color: '#ce2a1d' }}>{' '}<ErrorIcon /> {consentError}
                                    </span>                                    
                                )}
                                {' '}           
                            </span>                          
                            </CustomWidthTooltip>      
                            }                            
                        />        
                                                
                    )}
                </TabList>
                </Box>
                }
                <TabPanel value="1">     
                {
            
                    progressFlag === false && typeof(detail) === 'object' && !errorFlag
                    &&
                    
                    <>
                        <div className="row col-12 px-0 border border-0">
                            {
                                (entity === 'HCP') &&
                                filterdata.HCP.map((el, index) => {
                                    return (
                                        !el.isSeparateSingleKeySection &&
                                        <React.Fragment key={index}>
                                            <div className="col-sm-12 col-md-4 col-4">
                                                <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>
                                                    {el.heading}
                                                </Typography>
                                                {

                                                    el.attributes.map((value, key) => {

                                                        return (

                                                            (value.editable) &&

                                                            <SingleValue key={key}
                                                                 // to handle vn rdm values for IQVIA_US
                                                                vendor={vendor}
                                                                label={value.name}
                                                                change={changeCompleted}
                                                                mode={editable.includes('Edit') ? 'Edit' : 'Viewing'}
                                                                error={showError}
                                                                updatedValue={(newValue, flag) => updatedValue(newValue, value.id, undefined, flag)}
                                                                value={mapEditableAttributes(detail.entity[value.id])}
                                                                newValue={filterdata}
                                                                entity = {detail?.entity?.type?.split('/')[2]}
                                                                source = {detail?.entity?.Source}
                                                                country = {detail?.entity?.CountryCode}
                                                            />
                                                            ||
                                                            (!value.editable) &&

                                                            <SingleValue key={key}
                                                                label={value.name}
                                                                value={detail.entity[value.id]}
                                                                entity = {detail?.entity?.type?.split('/')[2]}
                                                                source = {detail?.entity?.Source}
                                                                country = {detail?.entity?.CountryCode}
                                                            />
                                                        )
                                                    })}
                                            </div>
                                        </React.Fragment>
                                    )
                                })}
                            {
                                (entity === 'HCO') &&
                                filterdata.HCO.map((el, index) => {
                                    return (
                                        !el.isSeparateSingleKeySection &&
                                        <React.Fragment key={index}>
                                            <div className="col-sm-12 col-md-4 col-4">
                                                <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>
                                                    {el.heading}
                                                </Typography>
                                                {

                                                    el.attributes.map((value, key) => {

                                                        return (

                                                            (value.editable) &&

                                                            <SingleValue key={key} mode={editable.includes('Edit') ? 'Edit' : 'Viewing'}
                                                                change={changeCompleted}
                                                                error={showError}
                                                                updatedValue={(newValue, flag) => updatedValue(newValue, value.id, undefined, flag)}
                                                                label={value.name}
                                                                value={detail.entity[value.id]}
                                                                newValue={filterdata}
                                                                entity = {detail?.entity?.type?.split('/')[2]}
                                                                source = {detail?.entity?.Source}
                                                                country = {detail?.entity?.CountryCode}
                                                            />
                                                            ||
                                                            (!value.editable) &&

                                                            <SingleValue key={key}
                                                                label={value.name}
                                                                value={detail.entity[value.id]}
                                                                entity = {detail?.entity?.type?.split('/')[2]}
                                                                source = {detail?.entity?.Source}
                                                                country = {detail?.entity?.CountryCode}
                                                            />
                                                        )
                                                    })}
                                            </div>
                                        </React.Fragment>
                                    )
                                })}
                       </div>
                        <div className="row col-12">
                            {(staticdata.showSpeciality) &&
                                <div className="card col-6 border border-0 ">
                                    <MultiValue vendor={vendor} freezEdit={detail.entity?.Source && jsondata.OPEN_DATA_SOURCES.includes(detail.entity?.Source[0]?.value)}
                                        specialtyDataSaved={specialtyDataSaved} source={checkSource(detail.entity.Source)}
                                        openSpecialtyModal={(val) => openSpecialtyModal(val)} entity={detail?.entity?.type?.split('/')[2]}
                                        addFlag={specialtyEdit} mode={editable.includes('Edit') ? 'Edit' : 'Viewing'} change={changeCompleted} error={showError} label={"Specialities"}
                                        updateValue={(newValue, flag) => updatedValue(newValue, 'NewSpecialities', true, flag)}
                                        heading={'Specialty'}
                                        value={mapResponse((Object.keys(specialtyList.Specialities).length > 0) || (specialtyList['NewSpecialities'] && specialtyList['NewSpecialities']['OtherSpecialty'] && specialtyList['NewSpecialities']['OtherSpecialty'][0]['value'].length > 0) ? transformSpecialityList(specialtyList) : detail.entity.Specialities)}
                                        editValue={(value, flag, name, index) => { updatedValue(value, (name != undefined ? name : 'NewSpecialities'), true, flag, undefined, index) }} />
                                </div>}
                            {(staticdata.showIdentifier) &&
                                <div className="card col-6 border border-0 ">
                                    <IdentifiersView {...identifierviewparams} entity={detail?.entity?.type?.split('/')[2]} oldProfile={true} source={checkSource(detail.entity.Source)} addFlag={typeHCP} mode={editable.includes('Edit') ? 'Edit' : 'Viewing'} change={changeCompleted} error={showError} label={"Identifiers"} updatedValue={(newValue, flag, index) => updatedValue(newValue, 'NewIdentifiers', true, flag, undefined, index)} heading={'Type&ID'} value={updateDetails.entity.NewIdentifiers} checkIdentifierSubmitted={(addflag, identifierType, identifierId, identifierSaved) => { checkIdentifierSubmitted(addflag, identifierType, identifierId, identifierSaved) }} submit={identifierSubmit} oldValue={identifierData} />
                                </div>
                            }
                            {
                                filterdata[entity === 'HCP' ? 'HCP' : 'HCO'].map((el) => {
                                    return (
                                        el?.isSeparateSingleKeySection &&
                                        <div className="card col-6 p-3 border border-0" key={el.heading}>
                                                <Accordion square className=" shadow-none" expanded={accordian}>
                                                    <AccordionSummary onClick={() => closeAccordian(accordian)}
                                                        expandIcon={<ExpandMoreIcon />}
                                                        aria-controls="panel1a-content"
                                                        id="Relation"
                                                        className='bg-grey'
                                                    >
                                                        <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>{el.heading}</Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails className='border row container ms-1'>
                                                        {
                                                            el.attributes.map((value, key) => {
                                                                if (detail.entity[value.id] && !separateSingleKeySectionDataAvailability?.[el.id]) {
                                                                    setSeparateSingleKeySectionDataAvailability(prevState => ({ ...prevState, [el.id]: true }))
                                                                }
                                                                return (

                                                                    (value.editable) &&
                                                                    <SingleValue key={key} mode={editable.includes('Edit') ? 'Edit' : 'Viewing'}
                                                                        change={changeCompleted}
                                                                        error={showError}
                                                                        updatedValue={(newValue, flag) => updatedValue(newValue, value.id, undefined, flag)}
                                                                        label={value.name}
                                                                        value={detail.entity[value.id]}
                                                                        newValue={filterdata}
                                                                        entity={detail?.entity?.type?.split('/')[2]}
                                                                        source={detail?.entity?.Source}
                                                                        country={detail?.entity?.CountryCode}
                                                                    /> ||
                                                                    (!value.editable) &&
                                                                    <SingleValue key={key}
                                                                        label={value.name}
                                                                        value={detail.entity[value.id]}
                                                                        entity={detail?.entity?.type?.split('/')[2]}
                                                                        source={detail?.entity?.Source}
                                                                        country={detail?.entity?.CountryCode}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                        {
                                                            (!separateSingleKeySectionDataAvailability?.[el.id]) &&
                                                            <div className='pt-2' id="details-text">
                                                                <em>No data found</em>
                                                            </div>
                                                        }
                                                    </AccordionDetails>
                                                </Accordion>
                                        </div>
                                    )
                                })
                            }
                        </div>
                   
                        {(staticdata.showAddress) &&
                            <div className="card border col-12 border-0 ">
                                
                                <MultiValue
                                    addFlag={typeHCP}
                                    mode={editable.includes('Edit') ? 'Edit' : 'Viewing'}
                                    change={changeCompleted}
                                    error={showError}
                                    label="Address" heading={'AddressLine1&City&Country'}
                                    value={mapResponse(detail.entity.Address, 'Address')}
                                    updateValue={(value, flag) => { updatedValue(value, 'AddAddress', undefined, flag) }}
                                    editValue={(value, flag, inputFieldName, index, editCancelIndex) => { updatedValue(value, 'Address', true, flag, inputFieldName, index, editCancelIndex) }}
                                    source = {checkSource(detail.entity.Source)}
                                    entity = {detail?.entity?.type?.split('/')[2]}
                                    addmoreAddressFlag = {( updateDetails.entity.AddAddress && updateDetails.entity.AddAddress.length > 0 && updateDetails.entity.Address && updateDetails.entity.Address.length >= 4) || (!updateDetails.entity.AddAddress && updateDetails.entity.Address && updateDetails.entity.Address.length >= 5)  ? true : false}
                                    // addmoreAddressFlag = {(updateDetails.entity.AddAddress  && updateDetails.entity.AddAddress.length > 0 && updateDetails.entity.Address && updateDetails.entity.Address.length == 1) || (!updateDetails.entity.AddAddress && updateDetails.entity.Address && updateDetails.entity.Address.length > 5)  ? true : false}
                                    country={detail.entity.CountryCode[0].value}
                                />
                            </div>
                        }

                        {(staticdata.showRelation) &&
                            <div className="card border col-12 border-0 ">
                                <Accordion square className=" shadow-none" expanded={accordian}>
                                    <AccordionSummary onClick={() => closeAccordian(accordian)}
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="Relation"
                                        className='bg-grey'
                                    >
                                        <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>Relation</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className='border row container ms-1'>
                                        {
                                            editable.includes('Edit') && typeHCP && (data.LILLY_MANAGED_SOURCES.includes(checkSource(detail.entity.Source)[0].value) ? updateDetails.relations && updateDetails.relations.length < 2 && addNewRelation !== true : addNewRelation !== true) &&
                                            <Link to="#" onClick={() => { setNewRelation(true); addRelationObject('add') }} id="list-text"><Add />ADD</Link>
                                        }
                                        {
                                            addNewRelation === true && editable.includes('Edit') && typeHCP
                                            &&
                                            <NewRelation entity = {detail?.entity?.type?.split('/')[2]} showRelationType={newrelation_source === 'VNDR-VOD' ? true : false} error={showError} country={detail.entity.CountryCode[0].value} Source={newrelation_source} AddNewRelation={(newValue, flag) => updatedValue(newValue, 'Relation', true, flag)} deleteNewItem={() => { setNewRelation(false); addRelationObject('remove') }}  
                                            searchHCOPayload={
                                                searchHCOPayload.search_hco_payload.country_config[
                                                    searchHCOPayload.search_hco_payload.country_config.hasOwnProperty(
                                                        detail.entity.CountryCode[0].value == 'United States' ? 'United States' : detail?.entity?.CountryCode[0]?.value
                                                    )
                                                        ? (detail.entity.CountryCode[0].value == 'United States' ? 'United States' : detail?.entity?.CountryCode[0]?.value)
                                                        : 'Default'
                                                ]
                                            }
                                            hcoQuery= {searchHCOPayload.search_hco_payload}/>
                                        }
                                        {
                                            !editable.includes('Edit') && detail.relations.length > 0
                                            && < NestedSearch search={(term) => { filterRelationTerm(term) }} label={'Relations'} />
                                        }
                                        {

                                            relationData && relationData.length > 0 && relationData.map((relation, i) => {                                                                                
                                                return (
                                                    < MultiValue 
                                                    source = {checkSource(detail.entity.Source)}
                                                    mode={editable.includes('Edit') ? 'Edit' : 'Viewing'} 
                                                    entity = {detail?.entity?.type?.split('/')[2]}  
                                                    key={i} label="Relation" 
                                                    id={id} value={relation}
                                                    index= {i} 
                                                    editValue={(value, flag, name, index) => { updatedValue(value,  (name != undefined ? name : 'Relation'), true, flag,undefined, index) }} 
                                                    editMode = {(editFlag) => disableEditIcon(editFlag, i)}
                                                    disableIcon = {addressEditIndex[i] != true  && updateDetails.relations  && updateDetails.relations.length == 5 ? true : false} 
                                                    country={detail.entity.CountryCode[0].value}
                                                />
                                                )
                                            })

                                        }
                                        {
                                            allRelation !== undefined && allRelation.length > CONSTANT.SHOW_VALUE_NUMBER && allRelation.length !== relationData.length &&
                                            <Link to='#' className='d-flex justify-content-center' onClick={showMore}> ShowMore <Add /> </Link>
                                        }
                                        {
                                            allRelation !== undefined && allRelation.length === relationData.length && relationData.length > CONSTANT.SHOW_VALUE_NUMBER &&
                                            <Link to='#' className='d-flex justify-content-center' onClick={showLess}> ShowLess<Remove /></Link>
                                        }
                                        {
                                            ((allRelation && allRelation.length === 0) || (allRelation === undefined)) &&
                                            <div className='pt-2' id="details-text">
                                                <em>No data found</em>
                                            </div>
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        }

                        <div className="row col-12">
                            {
                                !(staticdata?.hideSegmentation) &&
                                    <div className="card col-6 border border-0 ">
                                        <MultiValue label={"Segmentation"} heading={'Segmentation'} value={mapResponse(detail.entity.Segmentation)} />
                                    </div>
                            }
                            {
                                !(staticdata?.hideInsurance) &&
                                    <div className="card col-6 border border-0 ">
                                        <MultiValue label={"Insurance"} heading={'Program'} value={mapResponse(detail.entity.Insurance)} />
                                    </div>
                            }
                        </div>

                        <div className="row col-12">
                            {HCP && <div className="card border col-6 border-0 ">
                                <MultiValue label="Education" heading={'TypeofEducation'} value={mapResponse(detail.entity.Education)} />
                            </div>}
                                        {
                                            isEmployer ?
                                                <div className="card border col-6 border-0 ">
                                                    <MultiValue label="Website URL" heading={'URL'} value={mapResponse(detail.entity.WebsiteURL)} />
                                                </div> : !HCP ?
                                                    <div className="card border col-6 border-0 ">
                                                        <MultiValue label="Website URL" heading={'URL'} value={mapResponse(detail.entity.WebsiteURL)} />
                                                    </div> : null
                                        }      
                                        {
                                            staticdata?.showPhone && 
                                                <div className="card border col-6 border-0 ">
                                                    <MultiValue label="Phone" heading={'Number'} value={mapResponse(detail?.entity?.Phone)} />
                                                </div>
                                        }                                                                                                
                            <div className="card col-6 border border-0 ">
                                <MultiValue label={"Sources"} heading={'type'} value={detail.entity.crosswalks} />
                            </div>                  
                        </div>																                                                                                                                                               
                    </>
                }
                </TabPanel>
                <TabPanel value="2">
                    {consent &&                        
                    <Consents consentData = {consent} consentKeys = {consentKeys} consentProgressBar = {consentProgressBar} />
                    }

                </TabPanel>
                </TabContext>
            </Box>
            }
        {
            !progressFlag && detail !== undefined && !errorFlag && modalOpen !== undefined
            &&
            <Popup
                updateDetails={updateDetails}
                detail={detail}
                originalValues = {originalValue}
                closePopup={() => { setModalOpen({ flag: false }); setShowError(true); editable === 'Mark as Lilly Verified' ? setEditable('Viewing') : setEditable(editable); }}
                open={modalOpen.flag}
                success={modalOpen.success}
                message={modalOpen.message}
                title={modalOpen.title}
                close={() => { submitted() }}
                typeHCP={typeHCP}
                uri={id}
                source = {dcrSource[0].value}
                location = {'edit'}
                showConfirmationButton ={modalOpen.showConfirmationButton} 
                allowDeactivation={()=>allowDeactivation()}
            />
        }
        { !progressFlag && typeof(detail) === 'object' && !errorFlag && 
            <SpecialtyPopup vendor={vendor} count = {data.OPEN_DATA_SPECIALITY_LIMIT[entity] - Object.keys(showAllSpecialty?.Specialities)?.length} openSpecialtyModal = {(val)=>openSpecialtyModal(val)} open={showSpecialtyPopup} entity = {detail?.entity?.type?.split('/')[2]} addFlag={specialtyEdit} mode={editable.includes('Edit') ? 'Edit' : 'Viewing'} change={changeCompleted} error={showError} label={"Specialities"} updateValue={(newValue, flag) => updatedValue(newValue, 'NewSpecialities', true, flag)} heading={'Specialty'} value={mapResponse(detail.entity.Specialities)} editValue={(value, flag, name, index) => { updatedValue(value,  (name != undefined ? name : 'NewSpecialities'), true, flag,undefined, index) }}  />
        }
     
  
    </div >

)
}

export default Details;